<template>
  <!-- 合作伙伴 -->
  <div class="cooperativePartnerNav">
    <headerNav
      activeIndex="cooperativePartner"
      @setBanner="setBanner"
    ></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>

   <div class="pc">
     <div>
      <div style="width: 941px; margin: 96px auto 23px; text-align: center">
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #3f6b33;
            margin-bottom: 20px;
            line-height: 41px;
          "
        >
          长期稳定的合作伙伴
        </div>
        <div
          style="
            font-size: 20px;
            color: #313131;
            margin-bottom: 29px;
            line-height: 34px;
          "
        >
          <el-skeleton :loading="sysPartnerCooperationDesc === ''" animated>
            <template slot="template">
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </template>
            <template>
              <div style="text-align:center;" v-html="sysPartnerCooperationDesc"></div>
            </template>
          </el-skeleton>
        </div>
      </div>
    </div>

    <el-skeleton :loading="sysPartnerCooperationImages.length===0" animated>
      <template slot="template">
        <div
          style="
            margin: 0 auto;
            display: flex;
            align-items: center;
            width: 1168px;
            flex-wrap: wrap;
            background: #f6f9f5;
            padding: 40px 0 10px;
            justify-content: center;
          "
        >
        <el-skeleton-item variant="image" style="width: 240px;
                margin: 0 18px;height:135px" />
        <el-skeleton-item variant="image" style="width: 240px;
                margin: 0 18px;height:135px" />
        <el-skeleton-item variant="image" style="width: 240px;
                margin: 0 18px;height:135px" />
        <el-skeleton-item variant="image" style="width: 240px;
                margin: 0 18px;height:135px" />
        </div>
      </template>
      <template>
        <div
          style="
            margin: 0 auto;
            display: flex;
            align-items: center;
            width: 1168px;
            flex-wrap: wrap;
            background: #f6f9f5;
            padding: 40px 0 10px;
            justify-content: center;
          "
        >
          <div
            v-for="(item, index) of sysPartnerCooperationImages"
            :key="index"
            style="text-align: center"
            class="enlarge1"
          >
            <img
              :src="getUrlPrefix(item.images)"
              alt=""
              style="
                width: 240px;
                margin: 0 18px;
                margin-bottom: 36px;
                box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
                background: #fff;
              "
            />
          </div>
        </div>
      </template>
    </el-skeleton>
    <div>
      <div style="width: 100%; margin: 96px auto 23px; text-align: center">
        <div
          class="Regular"
          style="
            font-size: 41px;
            color: #3f6b33;
            margin-bottom: 16px;
            line-height: 41px;
          "
        >
          原液原料成功应用实证案例
        </div>
        <div
          style="
            font-size: 20px;
            color: #313131;
            margin-bottom: 29px;
            line-height: 34px;
          "
        >
        <el-skeleton :loading="!sysPartnerApplication.configValue" animated>
            <template slot="template">
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
              <el-skeleton-item variant="text" style="margin-right: 16px" />
            </template>
            <template>
             <div class="ql-editor" style="text-align:center;" v-html="sysPartnerApplication.configValue"></div>
            </template>
          </el-skeleton>
          
        </div>
      </div>
    </div>
    <div>
      <div
        style="margin-top: 50px; width: 1700px; margin: 50px auto"
        class="ql-editor"
        v-html="sysPartnerApplication.remark"
      ></div>
   </div>
    </div>
    <div class="mobile">
       <div  style="padding:0 0.2rem;">
         <div>
        <div style="margin: 0.2rem 0 ; text-align: center">
          <div
              style="
                color: #0f3a3c;
                font-weight: 600;
                margin-bottom: 0.1rem;
                text-align: center;
              "
               class="fzTitle"
            >
              长期稳定的合作伙伴
            </div>
          <div
            style="
              font-size: 0.16rem;
              line-height:1.5;
              color: #313131;
              margin-bottom: 0.2rem;
              text-align:left;
            "
          >
            <el-skeleton :loading="sysPartnerCooperationDesc === ''" animated>
              <template slot="template">
                <el-skeleton-item variant="text" style="margin-right: 16px" />
                <el-skeleton-item variant="text" style="margin-right: 16px" />
              </template>
              <template>
                <div style="white-space: pre-wrap;">{{sysPartnerCooperationDesc}}</div>
              </template>
            </el-skeleton>
          </div>
        </div>
      </div>

      <el-skeleton :loading="sysPartnerCooperationImages.length===0" animated>
        <template slot="template">
          <div
            style="
              margin: 0 auto;
              display: flex;
              align-items: center;
              width: 100%;
              flex-wrap: wrap;
              background: #f6f9f5;
              padding: 0.2rem 0 0.1rem;
              justify-content: center;
            "
          >
          <el-skeleton-item variant="image" style="width: 0.69rem;
                  margin: 0 0.05rem;height:0.39rem" />
          <el-skeleton-item variant="image" style="width: 0.69rem;
                  margin: 0 0.05rem;height:0.39rem" />
          <el-skeleton-item variant="image" style="width: 0.69rem;
                  margin: 0 0.05rem;height:0.39rem" />
          <el-skeleton-item variant="image" style="width: 0.69rem;
                  margin: 0 0.05rem;height:0.39rem" />
          </div>
        </template>
        <template>
          <div
            style="
              margin: 0 auto;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              background: #f6f9f5;
              padding: 0.2rem 0 0.1rem;
              justify-content: center;
            "
          >
            <div
              v-for="(item, index) of sysPartnerCooperationImages"
              :key="index"
              style="text-align: center"
              class="enlarge1"
            >
              <img
                :src="getUrlPrefix(item.images)"
                alt=""
                style="
                  width: 0.69rem;
                  margin: 0 0.05rem;
                  margin-bottom: 0.1rem;
                  box-shadow: 0px 2px 6px 0px rgba(63, 107, 51, 0.44);
                  background: #fff;
                "
              />
            </div>
          </div>
        </template>
      </el-skeleton>
      <div>
        <div style=" margin: 0.2rem auto; text-align: center">
          <div
              style="
                color: #0f3a3c;
                font-weight: 600;
                margin-top: -0.04rem;
                text-align: center;
              "
               class="fzTitle"
            >
              原液原料成功应用实证案例
            </div>
          <div
            style="
              color: #313131;
            "
          >
          <el-skeleton :loading="!sysPartnerApplication.configValue" animated>
              <template slot="template">
                <el-skeleton-item variant="text" style="margin-right: 0.1rem" />
                <el-skeleton-item variant="text" style="margin-right: 0.1rem" />
                <el-skeleton-item variant="text" style="margin-right: 0.1rem" />
                <el-skeleton-item variant="text" style="margin-right: 0.1rem" />
              </template>
              <template>
              <div 
                style="font-size: 0.16rem;line-height:1.5;margin:0.2rem 0.1rem;text-align:left;" >
                {{sysPartnerApplication.configValue || ''}}
                </div>
              </template>
            </el-skeleton>
            
          </div>
        </div>
      </div>
       </div>
      <div>
        <div
          style="margin-top: 0.2rem; width: 100%; margin: 0 auto"
          class="ql-editor"
          v-html="sysPartnerApplication.remark"
        ></div>
      </div>
    </div>
    <!-- 底部 -->

    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from '@/components/headerNav/index'
import bannerNav from '@/components/banner/index'
import footerNav from '@/components/footerNav/index'
import { getConfByKey } from '@/api/common'
import { getCarouselList } from '@/api/home'
export default {
  name: 'cooperativePartner',
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: '',
      }, //轮播图
      show: false,
      mobile: false,
      sysPartnerCooperationDesc: '',
      sysPartnerCooperationImages: [],
      sysPartnerApplication: {},
    }
  },

  mounted() {
    //初始化数据
    this.initializationData()
    if(this.isMobile() === true){
      this.postMessage(
          '御方汇植物化妆品原料【官网】',
          '合作伙伴',
          window.location.href,
          this.getUrlPrefix(this.getBaseInfo().logo)
        );
    }
  },
  methods: {
    setBanner(url,mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      }
    },
    initializationData() {
      //轮播图
      getCarouselList({ type: 2 }).then((response) => {
        this.sysPartnerCooperationImages = response.data
      })
      //合作伙伴描述
      getConfByKey({ key: 'sys.partner.cooperation.desc' }).then((response) => {
        this.sysPartnerCooperationDesc = response.data.configValue
        if(this.isMobile() === true){
          this.sysPartnerCooperationDesc = this.sysPartnerCooperationDesc.replace(/<br\/>/g,'')
        }
      })

      //合作伙伴-成功应用与转化
      getConfByKey({ key: 'sys.partner.application' }).then((response) => {
        this.sysPartnerApplication = response.data
        if(this.isMobile() === true){
          this.sysPartnerApplication.configValue = this.sysPartnerApplication.configValue.replace(/<br\/>/g,'')
        }
      })
    },
  },
}
</script>

<style lang="scss">
.cooperativePartnerNav {
}
</style>



// WEBPACK FOOTER //
// src/views/cooperativePartner/index.vue